import React from 'react';

const InputWrapper = ({ label, children, error }) => {
  return (
    <div className="input-wrapper mb-3">
      <label className="form-label w-100 truncate-text">
        <span>{label}</span>
      </label>
      {children}
      {error && <small className="text-danger">{error}</small>}
    </div>
  );
};

export default InputWrapper;